export default __webpack_public_path__ + "static/media/ducklings.b7de4003.jpg";